import { ReactNode } from 'react'
import { useNavigate, useHref } from 'react-router-dom'
import { RouterProvider } from 'react-aria-components'

export const ReactAriaRouterProvider = ({ children }: { children: ReactNode }) => {
  const navigate = useNavigate()
  return (
    <RouterProvider navigate={navigate} useHref={useHref}>
      {children}
    </RouterProvider>
  )
}
